import React, { StrictMode } from "react";
import { AuthProvider, useAuth } from "./AuthContext";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Notifications from "./components/pages/Notifications/Notifications";
import Observation from "./components/pages/Maps/Observation/Observation";
import LoginForm from "./components/pages/Login/LoginForm";
import Home from "./components/pages/Home/Home";
import Leak from "./components/pages/Maps/Leak/Leak";
import SideBar from "./components/pages/components/Sidebar/SideBar";
import "./App.css";
import { ObservationProvider } from "./components/pages/Maps/Observation/components/ObservationContext";

const PrivateRoute = ({ element }) => {
  const { authToken } = useAuth();
  return authToken ? element : <Navigate to="/login" />;
};

const AppContent = () => {
  const { authToken } = useAuth();

  return (
    <div className="App">
      {authToken && <SideBar />}
      <Routes>
        <Route path="/login" element={<LoginForm />} />
        <Route path="/" element={<PrivateRoute element={<Home />} />} />
        <Route
          path="/observations/:leakId"
          element={
            <PrivateRoute
              element={
                <ObservationProvider>
                  <Observation />
                </ObservationProvider>
              }
            />
          }
        />
        <Route path="/Leak" element={<PrivateRoute element={<Leak />} />} />
        <Route
          path="/Leak/:leakId"
          element={<PrivateRoute element={<Leak />} />}
        />
        <Route
          path="/notifications"
          element={<PrivateRoute element={<Notifications />} />}
        />
      </Routes>
    </div>
  );
};

const App = () => (
  <StrictMode>
    <AuthProvider>
      <BrowserRouter>
        <AppContent />
      </BrowserRouter>
    </AuthProvider>
  </StrictMode>
);

export default App;
